import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

const FilterModal = ({
                       config,
                       selected,
                       onToggle,
                       onDateChange,
                       onClear,
                       onApply,
                       show,
                       onClose,
                     }) => {
  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Filtry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {config.map((section) => (
          <div key={section.key} className="mb-4">
            <h6 className="mb-3">{section.label}</h6>

            {section.type === 'date-range' ? (
              <div className="d-flex gap-3">
                <Form.Group className="flex-fill">
                  <Form.Label>{section.labelFrom || 'Data od'}</Form.Label>
                  <Form.Control
                    type="date"
                    value={selected[section.key]?.from || ''}
                    onChange={(e) =>
                      onDateChange(section.key, 'from', e.target.value)
                    }
                  />
                </Form.Group>
                <Form.Group className="flex-fill">
                  <Form.Label>{section.labelTo || 'Data do'}</Form.Label>
                  <Form.Control
                    type="date"
                    value={selected[section.key]?.to || ''}
                    onChange={(e) =>
                      onDateChange(section.key, 'to', e.target.value)
                    }
                  />
                </Form.Group>
              </div>
            ) : (
              <div className="d-flex flex-wrap">
                {section.options.map((opt) => (
                  <div key={opt.value} className="w-50 mb-2">
                    <Form.Check
                      type="checkbox"
                      label={opt.label}
                      checked={selected[section.key]?.includes(opt.value) || false}
                      onChange={() => onToggle(section.key, opt.value)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="light" onClick={onClear}>
          Wyczyść
        </Button>
        <Button variant="primary" onClick={onApply}>
          Zastosuj
        </Button>
      </Modal.Footer>
    </Modal>
  );
};



export default FilterModal;
